import { Spacer } from '@spritz-finance/ui'
import React from 'react'
import styled from 'styled-components'
import { CenteredPageInner } from '../../../../components/Layout/PageContainer'
import { Row } from '../../../../components/Layout/Row'
import { Spinner } from '../../../../components/Spinner/Spinner'
import {
    PaymentProvider,
    useBillsDataQuery,
    usePaymentsInProgressQuery,
} from '../../../../graphql/generated/graphql'
import { NoPaymentsInProgress } from './NoPaymentsInProgress'
import { PaymentStatusFilter, usePaymentStatusFilter } from './PaymentStatusFilter'
import { DirectPaymentCard } from './DirectPaymentCard'

const AccountsContainer = styled.div`
    padding-bottom: 72px;
`

export const PaymentsInProgress: React.VFC<{
    provider: PaymentProvider
    EmptyState?: () => JSX.Element
    paymentType: 'offramp' | 'regular'
}> = ({ provider, EmptyState = NoPaymentsInProgress, paymentType }) => {
    const { data, loading } = usePaymentsInProgressQuery({
        fetchPolicy: 'cache-and-network',
    })
    const { loading: loadingBills } = useBillsDataQuery()

    const payments =
        data?.paymentsInProgress
            .filter((p) => p?.account?.type !== 'SPRITZ_CARD')
            .filter((payment) => {
                const isOfframp =
                    payment.paymentProvider === PaymentProvider.Checkbook &&
                    payment?.account?.ownedByUser
                return paymentType === 'offramp' ? isOfframp : !isOfframp
            }) ?? []

    const { filteredPayments, statusOptions, setStatusFilter } = usePaymentStatusFilter(payments)

    if ((!data && loading) || loadingBills) {
        return <Spinner />
    }

    if (payments.length === 0) return <EmptyState />

    return (
        <CenteredPageInner $width={564}>
            <AccountsContainer>
                <Row align="flex-end">
                    <PaymentStatusFilter
                        options={statusOptions}
                        setStatusFilter={setStatusFilter}
                    />
                </Row>
                <Spacer height={16} />
                {filteredPayments.map((payment, index) => (
                    <React.Fragment key={index}>
                        <DirectPaymentCard key={payment.id} payment={payment} />
                        {index !== filteredPayments.length - 1 && <Spacer height={32} />}
                    </React.Fragment>
                ))}
            </AccountsContainer>
        </CenteredPageInner>
    )
}
